import amberSrc from "~/assets/images/fuzzies/amber.png";
import blueSrc from "~/assets/images/fuzzies/blue.png";
import blueAmberSrc from "~/assets/images/fuzzies/blue-amber.png";

export const FUZZY_SOURCES = {
  blue: blueSrc,
  amber: amberSrc,
  "blue+amber": blueAmberSrc,
};

export type Fuzzy = keyof typeof FUZZY_SOURCES;

export const assertFuzzy = (fuzzy: string): Fuzzy => {
  if (fuzzy in FUZZY_SOURCES) {
    return fuzzy as Fuzzy;
  }
  throw new Error(`Invalid Fuzzy variant: ${fuzzy}`);
};
